import {Avatar, Button, List, Tag, Typography} from "antd";

export const PositivityList = ({ data, isLoading }) => {

  return(
    <List
      header={<div style={{ textAlign: 'center' }}>
        <Typography.Text strong style={{ fontSize: 20 }}>Positivity Statistics</Typography.Text>
      </div>}
      size="large"
      loading={isLoading}
      bordered
      dataSource={data}
      renderItem={item => (
        <List.Item>
          <Typography.Text>
            <Avatar
              style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            >
              {item.name[0].toUpperCase()}
            </Avatar> <Button type="link">{item.name}</Button>
          </Typography.Text>
          <Tag color="#108ee9">{item.count}</Tag>
        </List.Item>
      )}
    />
  )
}